/* Ranó Mi theme behaviour: bag drawer, favourites, quick add, runway, rails, search, filters, forms. */
(function () {
  'use strict';
  var RM = window.RM || (window.RM = {});
  var S = RM.str || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (RM.root || '/').replace(/\/?$/, '/');

  /* ---------- helpers ---------- */
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }
  function money(cents) {
    // The shop format can carry markup (e.g. <span class=money>); callers escape the result, so keep text only.
    var fmt = (RM.moneyFormat || '{{amount}}').replace(/<[^>]*>/g, '');
    var n = (cents || 0) / 100;
    function f(dec, th, ds) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return f(0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return f(2, "'", '.');
      return f(2, ',', '.');
    });
  }
  RM.money = money;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  RM.esc = esc;

  var toastBox = $('.toasts');
  RM.toast = function (msg, opts) {
    opts = opts || {};
    if (!toastBox) return;
    var t = document.createElement('div');
    t.className = 'toast';
    t.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span></span>';
    t.querySelector('span').textContent = msg;
    if (opts.action) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = opts.action;
      b.addEventListener('click', function () { opts.onAction && opts.onAction(); t.remove(); });
      t.appendChild(b);
    }
    toastBox.appendChild(t);
    setTimeout(function () { t.remove(); }, opts.ms || 3200);
  };

  var lastFocus = null;
  function openLayer(el, focusSel) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.classList.add('lock');
    var f = focusSel ? $(focusSel, el) : $('button, a, input, select, textarea', el);
    if (f) setTimeout(function () { f.focus(); }, 30);
  }
  function closeLayer(el) {
    if (!el || el.hidden) return;
    el.hidden = true;
    if (!$('.sheet:not([hidden]), [data-cart-drawer]:not([hidden]), [data-search-overlay]:not([hidden]), [data-filters]:not([hidden]), [data-guide]:not([hidden]), [data-viewer]:not([hidden])')) document.body.classList.remove('lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  RM.openLayer = openLayer;
  RM.closeLayer = closeLayer;
  function trapTab(e, el) {
    if (e.key !== 'Tab') return;
    var items = $$('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', el).filter(function (x) { return x.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  }
  document.addEventListener('keydown', function (e) {
    var open = $$('.sheet:not([hidden]), [data-cart-drawer]:not([hidden]), [data-search-overlay]:not([hidden]), [data-filters]:not([hidden]), [data-guide]:not([hidden]), [data-viewer]:not([hidden])');
    if (!open.length) return;
    var top = open[open.length - 1];
    if (e.key === 'Escape') { closeLayer(top); return; }
    trapTab(e, top);
  });

  /* ---------- header: menu sheet + search ---------- */
  // Long labels (TR, AR) never wrap: when the links overflow their column, fall back to the menu button.
  var hdr = $('[data-header]'), hdrNav = hdr && $('.nav', hdr);
  function fitNav() {
    if (!hdrNav) return;
    hdr.classList.remove('is-compact');
    if (getComputedStyle(hdrNav).display === 'none') return;
    if (hdrNav.scrollWidth > hdrNav.clientWidth + 1) hdr.classList.add('is-compact');
  }
  fitNav();
  window.addEventListener('resize', fitNav);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitNav);
  var sheet = $('[data-menu]');
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) { openLayer(sheet); $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); }); }
    else if (t.closest('[data-menu-close]')) { closeLayer(sheet); $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
    else if (t.closest('[data-search-open]')) { e.preventDefault(); if (sheet) closeLayer(sheet); openLayer($('[data-search-overlay]'), '[data-search-input]'); }
    else if (t.closest('[data-search-close]') || t.matches('[data-search-overlay]')) { closeLayer($('[data-search-overlay]')); }
  });
  var sInput = $('[data-search-input]'), sOut = $('[data-search-results]'), sTimer = null, sCtrl = null;
  if (sInput && sOut) {
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      if (!q) { sOut.innerHTML = ''; return; }
      sTimer = setTimeout(function () {
        if (sCtrl) sCtrl.abort();
        sCtrl = 'AbortController' in window ? new AbortController() : null;
        fetch((RM.searchUrl || '/search/suggest') + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,page,query&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,vendor,tag', sCtrl ? { signal: sCtrl.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var d = new DOMParser().parseFromString(html, 'text/html');
            var sec = d.querySelector('#shopify-section-predictive-search') || d.body;
            sOut.innerHTML = sec.innerHTML;
          }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- bag ---------- */
  var drawerWrap = $('[data-cart-drawer]');
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function renderDrawer(html) {
    if (!html || !drawerWrap) return;
    var d = new DOMParser().parseFromString(html, 'text/html');
    var aside = d.querySelector('[data-cart-drawer] aside');
    var cur = $('aside', drawerWrap);
    if (aside && cur) cur.innerHTML = aside.innerHTML;
    var c = d.querySelector('[data-cart-count]');
    if (c) setCount(c.textContent.trim());
  }
  function openCart() {
    if (!drawerWrap || document.body.classList.contains('tpl-cart')) { window.location.href = RM.cartUrl || '/cart'; return; }
    openLayer(drawerWrap, '[data-cart-close]:not(.scrim)');
  }
  RM.openCart = openCart;
  RM.refreshCart = function () {
    return fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (j) { renderDrawer(j['cart-drawer']); });
  };
  RM.addToCart = function (items, opts) {
    opts = opts || {};
    return fetch((RM.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || S.cartError);
        return j;
      });
    }).then(function (j) {
      if (j.sections) renderDrawer(j.sections['cart-drawer']);
      if (opts.toast !== false) RM.toast(opts.title ? S.addedNamed.replace('__T__', opts.title) : S.added, { action: S.cartView, onAction: openCart });
      if (opts.open) openCart();
      document.dispatchEvent(new CustomEvent('rm:cart-added', { detail: j }));
      return j;
    }).catch(function (err) {
      RM.toast(err && err.message ? err.message : S.cartError, { ms: 4500 });
      throw err;
    });
  };
  function changeLine(line, qty) {
    var body = $('[data-cart-body]', drawerWrap);
    if (body) body.classList.add('cart-busy');
    return fetch((RM.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (j.status) RM.toast(j.description || S.cartError);
      if (j.sections) renderDrawer(j.sections['cart-drawer']);
    }).finally(function () { var b = $('[data-cart-body]', drawerWrap); if (b) b.classList.remove('cart-busy'); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest('[data-cart-open]');
    if (open && drawerWrap && !document.body.classList.contains('tpl-cart')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { closeLayer(drawerWrap); return; }
    var q = t.closest('[data-cart-drawer] [data-qty]');
    if (q) { var line = q.closest('[data-line]'); changeLine(+line.dataset.line, Math.max(0, +q.dataset.qty)); return; }
    var qa = t.closest('[data-quick-add]');
    if (qa) {
      qa.disabled = true;
      RM.addToCart([{ id: +qa.dataset.quickAdd, quantity: 1 }], { title: qa.dataset.title + (qa.textContent.length < 12 ? ', ' + qa.textContent : '') })
        .finally(function () { qa.disabled = false; });
    }
  });

  /* ---------- favourites ---------- */
  var FKEY = 'rm:favs';
  function favs() {
    var list = store(FKEY);
    if (!Array.isArray(list)) {
      list = [];
      var legacy = store('wishListsArr');
      if (Array.isArray(legacy)) legacy.forEach(function (x) { var h = typeof x === 'string' ? x : (x && (x.handle || x.h)); if (h && /^[a-z0-9][a-z0-9-]*$/i.test(h)) list.push({ h: h, t: Date.now() }); });
      store(FKEY, list);
    }
    return list;
  }
  RM.favs = favs;
  function isFav(h) { return favs().some(function (x) { return x.h === h; }); }
  function syncFavs() {
    var list = favs();
    $$('[data-fav]').forEach(function (b) { b.setAttribute('aria-pressed', isFav(b.dataset.fav) ? 'true' : 'false'); });
    $$('[data-fav-count]').forEach(function (el) { el.textContent = list.length || ''; el.setAttribute('data-n', list.length); });
  }
  RM.syncFavs = syncFavs;
  RM.setFav = function (h, on, silent) {
    var list = favs().filter(function (x) { return x.h !== h; });
    if (on) list.unshift({ h: h, t: Date.now() });
    store(FKEY, list);
    syncFavs();
    document.dispatchEvent(new CustomEvent('rm:favs'));
    if (!silent) RM.toast(on ? S.favAdded : S.favRemoved, { action: S.undo, onAction: function () { RM.setFav(h, !on, true); } });
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault();
    RM.setFav(b.dataset.fav, !isFav(b.dataset.fav));
  });
  syncFavs();

  /* ---------- product JSON cache ---------- */
  var pCache = {};
  RM.product = function (h) {
    if (!pCache[h]) pCache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { if (!r.ok) throw new Error('404'); return r.json(); });
    return pCache[h];
  };
  function img(src, w) {
    if (!src) return '';
    src = src.replace(/^https?:/, '');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  RM.img = img;

  /* ---------- favourites page ---------- */
  var favPage = $('[data-favorites]');
  if (favPage) (function () {
    var grid = $('[data-fav-grid]', favPage), empty = $('[data-fav-empty]', favPage), shareBtn = $('[data-fav-share]', favPage);
    var d = favPage.dataset, picked = {};
    var params = new URLSearchParams(window.location.search);
    var shared = params.get('items');
    if (shared) {
      shared.split(',').forEach(function (h) { if (h && !isFav(h)) RM.setFav(h, true, true); });
      history.replaceState(null, '', window.location.pathname);
    }
    var sizeNames = (S.sizeNames || 'size').split(',');
    function card(p, saved) {
      var name = p.title, colour = '';
      if (name.indexOf(' — ') > -1) { colour = name.split(' — ').pop(); name = name.split(' — ')[0]; }
      var pack = null;
      (p.media || []).forEach(function (m) { if (!pack && m.alt && /product only/i.test(m.alt)) pack = m.src || (m.preview_image && m.preview_image.src); });
      var single = p.variants.length === 1;
      var sizeOpt = p.options.length === 1 && sizeNames.indexOf(String(p.options[0].name || p.options[0]).toLowerCase()) > -1;
      var price = p.price === 0 ? d.strSoon : money(p.price);
      var sizes = '';
      if (!single) {
        sizes = '<div class="sizes" role="radiogroup" aria-label="' + esc(d.strSize) + '">' + p.variants.slice(0, 8).map(function (v) {
          return '<button class="size" type="button" role="radio" aria-checked="false" data-v="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(sizeOpt ? v.option1 : v.title) + '</button>';
        }).join('') + '</div><p class="err" role="alert" hidden>' + esc(d.strChoose) + '</p>';
      }
      var canBuy = p.available && p.price > 0;
      var label = !p.available ? d.strSold : (p.price === 0 ? d.strSoon : d.strAdd);
      return '<article class="fav" data-h="' + esc(p.handle) + '"' + (single ? ' data-single="' + p.variants[0].id + '"' : '') + '>' +
        '<div class="card-media"><a href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '" data-cursor>' +
        (p.featured_image ? '<img class="main" src="' + img(p.featured_image, 700) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        (pack ? '<span class="alt-wrap pack"><img src="' + img(pack, 700) + '" alt="" loading="lazy"></span>' : '') +
        '</a><span class="saved"><svg width="11" height="11" viewBox="0 0 24 24" fill="#9B4D67" aria-hidden="true"><path d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0112 7.4 4.3 4.3 0 0119.5 10c0 5.4-7.5 10-7.5 10z"/></svg>' + esc(d.strSaved) + '</span>' +
        '<button class="rm-x" type="button" aria-label="' + esc(d.strRemove) + ': ' + esc(p.title) + '" data-unfav><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
        '<div class="card-info"><a href="' + esc(p.url) + '">' + esc(name) + '</a><span class="pr">' + esc(price) + '</span></div>' +
        (colour ? '<p class="card-col">' + esc(colour) + '</p>' : '') + sizes +
        '<button class="btn" type="button" data-fav-add' + (canBuy ? '' : ' disabled') + '><span class="roll"><span>' + esc(label) + '</span><span aria-hidden="true">' + esc(label) + '</span></span></button></article>';
    }
    function render() {
      var list = favs();
      $$('[data-fav-count]', favPage).forEach(function (el) { el.textContent = list.length || ''; });
      shareBtn.hidden = list.length === 0;
      if (!list.length) { grid.hidden = true; empty.hidden = false; grid.innerHTML = ''; return; }
      empty.hidden = true; grid.hidden = false;
      if (!grid.children.length) grid.innerHTML = list.map(function () { return '<div class="fav"><div class="card-media skel"></div></div>'; }).join('');
      Promise.all(list.map(function (x) { return RM.product(x.h).catch(function () { return null; }); })).then(function (ps) {
        var html = ps.map(function (p, i) { return p ? card(p, list[i]) : ''; }).join('');
        grid.innerHTML = html;
        if (!html) { grid.hidden = true; empty.hidden = false; }
      });
    }
    grid.addEventListener('click', function (e) {
      var art = e.target.closest('.fav'); if (!art) return;
      var sz = e.target.closest('.size');
      if (sz) {
        $$('.size', art).forEach(function (b) { b.setAttribute('aria-checked', b === sz ? 'true' : 'false'); });
        picked[art.dataset.h] = sz.dataset.v;
        $('.sizes', art).classList.remove('bad'); var er = $('.err', art); if (er) er.hidden = true;
        return;
      }
      if (e.target.closest('[data-unfav]')) { RM.setFav(art.dataset.h, false); return; }
      var add = e.target.closest('[data-fav-add]');
      if (add) {
        var id = art.dataset.single || picked[art.dataset.h];
        if (!id) { var s2 = $('.sizes', art); if (s2) s2.classList.add('bad'); var er2 = $('.err', art); if (er2) er2.hidden = false; return; }
        add.setAttribute('aria-busy', 'true');
        RM.addToCart([{ id: +id, quantity: 1 }], { title: $('.card-info a', art).textContent }).then(function () {
          add.classList.add('done');
          $$('.roll span', add).forEach(function (s) { s.textContent = d.strInbag; });
        }).finally(function () { add.removeAttribute('aria-busy'); });
      }
    });
    shareBtn.addEventListener('click', function () {
      var url = window.location.origin + window.location.pathname + '?items=' + favs().map(function (x) { return x.h; }).join(',');
      if (navigator.share) navigator.share({ url: url, title: document.title }).catch(function () {});
      else if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { RM.toast(d.strShared); });
    });
    document.addEventListener('rm:favs', render);
    render();
  })();

  /* ---------- recently viewed ---------- */
  var recent = $('[data-recent]');
  var current = $('[data-product]');
  if (current && current.dataset.handle) {
    var rl = (store('rm:recent') || []).filter(function (h) { return h !== current.dataset.handle; });
    rl.unshift(current.dataset.handle);
    store('rm:recent', rl.slice(0, 9));
  }
  if (recent) {
    var cur = recent.dataset.current;
    var list = (store('rm:recent') || []).filter(function (h) { return h !== cur; }).slice(0, 4);
    if (list.length) {
      Promise.all(list.map(function (h) { return RM.product(h).catch(function () { return null; }); })).then(function (ps) {
        var html = ps.filter(Boolean).map(function (p) {
          var name = p.title.split(' — ')[0], colour = p.title.indexOf(' — ') > -1 ? p.title.split(' — ').pop() : (p.price ? money(p.price) : '');
          return '<a class="mini" href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + img(p.featured_image, 200) + '" alt="" loading="lazy" width="84" height="110">' : '') + '<p>' + esc(name) + '<span>' + esc(colour) + '</span></p></a>';
        }).join('');
        if (html) { $('[data-recent-list]', recent).innerHTML = html; recent.hidden = false; }
      });
    }
  }

  /* ---------- rails ---------- */
  function initRail(wrap) {
    var rail = $('[data-rail]', wrap); if (!rail || rail.dataset.ready) return;
    rail.dataset.ready = '1';
    var bar = $('[data-rail-bar]', wrap);
    var rtl = document.documentElement.dir === 'rtl';
    function step() { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : 300; }
    function upd() {
      if (!bar) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var vis = rail.clientWidth / rail.scrollWidth;
      var pos = max > 0 ? Math.abs(rail.scrollLeft) / max : 0;
      bar.style.setProperty('--w', Math.max(12, vis * 100) + '%');
      bar.style.setProperty('--x', (pos * (1 / Math.max(vis, .01) - 1) * 100) + '%');
    }
    var prev = $('[data-rail-prev]', wrap), next = $('[data-rail-next]', wrap);
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: (rtl ? 1 : -1) * step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: (rtl ? -1 : 1) * step(), behavior: reduce ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }
  RM.initRail = initRail;
  $$('[data-rail-wrap]').forEach(initRail);

  /* ---------- runway ---------- */
  $$('[data-runway]').forEach(function (rw) {
    var figs = $$('[data-look]', rw), ticks = $$('[data-look-tick]', rw), panels = $$('[data-look-panel]', rw);
    var n = figs.length; if (!n) return;
    var active = Math.min(n - 1, +rw.dataset.start || 0);
    var num = $('[data-look-num]', rw), prev = $('[data-look-prev]', rw), next = $('[data-look-next]', rw);
    var rtl = document.documentElement.dir === 'rtl';
    function render() {
      figs.forEach(function (f, i) {
        var d = active - i, x, sc, blur, op, z;
        if (d === 0) { x = 60; sc = 1; blur = 0; op = 1; z = 20; }
        else if (d > 0) { x = 60 - 15 * (1 - Math.pow(0.68, d)) / 0.32; sc = Math.pow(0.82, d); blur = Math.min(10, 2.2 * Math.pow(d, 1.25)); op = d > 4 ? 0 : 1 - d * 0.15; z = 20 - d; }
        else { x = 60 + 30 * Math.min(-d, 2); sc = 1.02; blur = 0; op = d === -1 ? 0.5 : 0; z = 21; }
        if (rtl) x = 100 - x;
        f.style.transform = 'translateX(calc(' + x.toFixed(2) + 'cqw - 50%)) scale(' + sc.toFixed(3) + ')';
        f.style.filter = blur > 0 ? 'blur(' + blur.toFixed(1) + 'px)' : 'none';
        f.style.opacity = op.toFixed(2);
        f.style.zIndex = z;
        f.setAttribute('aria-hidden', op === 0 ? 'true' : 'false');
        f.tabIndex = op === 0 ? -1 : 0;
      });
      ticks.forEach(function (t, i) { t.setAttribute('aria-current', i === active ? 'true' : 'false'); });
      panels.forEach(function (p, i) { p.hidden = i !== active; });
      if (num) num.textContent = active + 1;
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active === n - 1;
    }
    function go(i) { active = Math.max(0, Math.min(n - 1, i)); render(); }
    figs.forEach(function (f, i) { f.addEventListener('click', function () { go(i); }); });
    ticks.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    if (prev) prev.addEventListener('click', function () { go(active - 1); });
    if (next) next.addEventListener('click', function () { go(active + 1); });
    var stage = $('[data-stage]', rw), sx = null;
    if (stage) {
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { go(active + (rtl ? 1 : -1)); e.preventDefault(); }
        if (e.key === 'ArrowRight') { go(active + (rtl ? -1 : 1)); e.preventDefault(); }
      });
      stage.addEventListener('pointerdown', function (e) { sx = e.clientX; });
      stage.addEventListener('pointerup', function (e) {
        if (sx === null) return; var dx = e.clientX - sx; sx = null;
        if (Math.abs(dx) > 40) go(active + ((dx < 0) !== rtl ? 1 : -1));
      });
    }
    render();
  });

  /* ---------- film: play / pause, pause off-screen ---------- */
  $$('[data-hero-video]').forEach(function (v) {
    var btn = v.parentElement.querySelector('[data-video-toggle]');
    var wanted = !reduce;
    function sync() {
      if (!btn) return;
      btn.setAttribute('aria-pressed', wanted ? 'true' : 'false');
      btn.setAttribute('aria-label', wanted ? S.pause : S.play);
    }
    function play() { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!wanted) v.pause(); else play();
    sync();
    if (btn) btn.addEventListener('click', function () { wanted = !wanted; if (wanted) play(); else v.pause(); sync(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (!wanted) return; if (en.isIntersecting) play(); else v.pause(); });
    }, { threshold: 0.1 }).observe(v);
  });

  /* ---------- "View" cursor on product images ---------- */
  var cursor = $('.cursor');
  if (cursor && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mousemove', function (e) {
      var on = e.target.closest && e.target.closest('[data-cursor]');
      cursor.classList.toggle('on', !!on);
      if (on) cursor.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';
    }, { passive: true });
  }

  /* ---------- accordions (product info, FAQs) ---------- */
  document.addEventListener('click', function (e) {
    var h = e.target.closest('.acc-h, .qa-h');
    if (!h) return;
    var item = h.parentElement;
    var open = item.getAttribute('data-open') === 'true';
    item.setAttribute('data-open', open ? 'false' : 'true');
    h.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  /* ---------- FAQ search + categories ---------- */
  $$('[data-faq]').forEach(function (fq) {
    var items = $$('.qa-item', fq), input = $('[data-faq-q]', fq), none = $('[data-faq-none]', fq), cat = 'all';
    var btns = $$('[data-faq-cats] button', fq);
    btns.forEach(function (b) {
      var c = b.dataset.cat;
      var n = c === 'all' ? items.length : items.filter(function (i) { return i.dataset.cat === c; }).length;
      var small = $('[data-n]', b); if (small) small.textContent = n;
      if (!n && c !== 'all') b.hidden = true;
      b.addEventListener('click', function () { cat = c; btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); apply(); });
    });
    function apply() {
      var q = (input && input.value || '').trim().toLowerCase(), shown = 0;
      items.forEach(function (it) {
        var ok = (cat === 'all' || it.dataset.cat === cat) && (!q || it.textContent.toLowerCase().indexOf(q) > -1);
        it.hidden = !ok; if (ok) shown++;
      });
      if (none) none.hidden = shown > 0;
    }
    if (input) input.addEventListener('input', apply);
  });

  /* ---------- share popovers ---------- */
  document.addEventListener('click', function (e) {
    var tg = e.target.closest('[data-share-toggle]');
    $$('[data-share-pop]').forEach(function (p) {
      if (tg && p.parentElement.contains(tg)) { p.hidden = !p.hidden; tg.setAttribute('aria-expanded', p.hidden ? 'false' : 'true'); }
      else if (!e.target.closest('[data-share]')) { p.hidden = true; }
    });
    var cp = e.target.closest('[data-copy-link]');
    if (cp && navigator.clipboard) { navigator.clipboard.writeText(cp.dataset.copyLink).then(function () { RM.toast(S.linkCopied); }); cp.closest('[data-share-pop]').hidden = true; }
  });

  /* ---------- collection: sort, density, filters, load more ---------- */
  var coll = $('[data-collection]');
  if (coll) {
    var sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); window.location.href = u.toString();
    });
    var grid = $('[data-grid]', coll);
    var dens = $$('[data-cols]');
    function setCols(c) { if (grid) grid.style.setProperty('--cols', c); dens.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.cols === String(c) ? 'true' : 'false'); }); }
    dens.forEach(function (b) { b.addEventListener('click', function () { setCols(b.dataset.cols); store('rm:cols', b.dataset.cols); }); });
    if (window.innerWidth >= 1024 && store('rm:cols')) setCols(store('rm:cols'));
    coll.addEventListener('click', function (e) {
      var more = e.target.closest('[data-load-more]');
      if (!more) return;
      e.preventDefault();
      more.setAttribute('aria-busy', 'true');
      fetch(more.href).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var g2 = d.querySelector('[data-grid]'), m2 = d.querySelector('[data-more]');
        if (g2) Array.prototype.slice.call(g2.children).forEach(function (c) { grid.appendChild(c); });
        var m1 = $('[data-more]', coll);
        if (m1 && m2) m1.replaceWith(m2);
        syncFavs();
        history.replaceState(null, '', more.href);
      });
    });
  }
  var filters = $('[data-filters]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-open]')) openLayer(filters, '[data-filter-close]:not(.scrim)');
    if (e.target.closest('[data-filter-close]')) closeLayer(filters);
  });

  /* ---------- newsletter: client-side email check ---------- */
  $$('.news-form').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      var inp = $('input[type=email]', f), err = $('[data-email-err]', f);
      if (!inp) return;
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(inp.value.trim());
      inp.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (err) err.hidden = ok;
      if (!ok) { e.preventDefault(); inp.focus(); }
    });
  });

  /* ---------- contact page ---------- */
  var cf = $('#rm-contact');
  if (cf) (function () {
    var topicIn = $('[data-topic-input]', cf), chips = $$('[data-topic]', cf);
    var order = $('[data-order-field]', cf), hint = $('[data-ws-hint]', cf);
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        topicIn.value = c.dataset.topic;
        var k = c.dataset.kind;
        if (order) order.hidden = !(k === 't_order' || k === 't_return');
        if (hint) hint.hidden = k !== 't_wholesale';
        var er = $('[data-err=topic]', cf); if (er) er.hidden = true;
        $('[data-topics]', cf).classList.remove('bad');
      });
    });
    function check(el) {
      var v = el.value.trim(), k = el.dataset.req, ok = !!v;
      if (k === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
      if (k === 'phone') ok = (v.match(/\d/g) || []).length >= 7;
      if (k === 'msg') ok = v.length >= 10;
      el.setAttribute('aria-invalid', ok ? 'false' : 'true');
      var er = $('[data-err=' + k + ']', cf); if (er) er.hidden = ok;
      return ok;
    }
    $$('[data-req]', cf).forEach(function (el) { el.addEventListener('blur', function () { if (el.value) check(el); }); });
    cf.addEventListener('submit', function (e) {
      var ok = true, first = null;
      if (topicIn && !topicIn.value) { ok = false; var er = $('[data-err=topic]', cf); if (er) er.hidden = false; $('[data-topics]', cf).classList.add('bad'); first = first || chips[0]; }
      $$('[data-req]', cf).forEach(function (el) { if (!check(el)) { ok = false; first = first || el; } });
      if (!ok) { e.preventDefault(); if (first) first.focus(); }
      else { var b = $('button[type=submit]', cf); if (b) b.setAttribute('aria-busy', 'true'); }
    });
  })();
  var sent = $('[data-autofocus]'); if (sent) { sent.scrollIntoView({ block: 'center' }); sent.focus({ preventScroll: true }); }

  /* ---------- office open / closed ---------- */
  $$('[data-open-status]').forEach(function (el) {
    try {
      var tz = el.dataset.tz || 'Europe/Istanbul';
      var days = (el.dataset.days || '1,2,3,4,5').split(',').map(Number);
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var get = function (t) { return (parts.find(function (p) { return p.type === t; }) || {}).value; };
      var wd = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
      var mins = (+get('hour') % 24) * 60 + (+get('minute'));
      var toM = function (s) { var a = String(s || '0:0').split(':'); return (+a[0]) * 60 + (+a[1] || 0); };
      var open = days.indexOf(wd) > -1 && mins >= toM(el.dataset.open) && mins < toM(el.dataset.close);
      el.classList.toggle('closed', !open);
      $('span', el).textContent = open ? el.dataset.openText : el.dataset.closedText;
      el.hidden = false;
      $$('[data-hours] tr').forEach(function (tr) {
        var dd = tr.dataset.day;
        tr.classList.toggle('is-today', dd === 'weekdays' ? days.indexOf(wd) > -1 : +dd === wd);
      });
    } catch (e) {}
  });
})();
